import {
  createProduct,
  updateProduct,
  deleteProduct,
  getProductDetail,
  getProductList,
  changeProductStatus
} from '@/api/product';
import { fetchStoreAppClassificationList } from '@/api/appClassification';

const product = {
  state: {
    productList: [],
    productDetail: null,
    productTotal: 0,
    categoryList: []
  },

  mutations: {
    SET_PRODUCT_LIST: (state, list) => {
      state.productList = list;
    },
    SET_PRODUCT_DETAIL: (state, detail) => {
      state.productDetail = detail;
    },
    SET_PRODUCT_TOTAL: (state, total) => {
      state.productTotal = total;
    },
    SET_CATEGORY_LIST: (state, list) => {
      state.categoryList = list;
    }
  },

  actions: {
    // 创建商品
    CreateProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        createProduct(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 更新商品
    UpdateProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateProduct(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 删除商品
    DeleteProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteProduct(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取商品详情
    GetProductDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getProductDetail(params)
          .then((response) => {
            commit('SET_PRODUCT_DETAIL', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取商品列表
    GetProductList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getProductList(params)
          .then((response) => {
            if (response) {
              commit('SET_PRODUCT_LIST', response.products || []);
              commit('SET_PRODUCT_TOTAL', response.total || 0);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 更改商品状态
    ChangeProductStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        changeProductStatus(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取分类列表
    GetCategoryList({ commit }, params) {
      return new Promise((resolve, reject) => {
        fetchStoreAppClassificationList(params)
          .then((response) => {
            commit('SET_CATEGORY_LIST', response || []);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default product;



// WEBPACK FOOTER //
// ./src/store/modules/product.js